/**
 * PlanningEventEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90001
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { PlanningEventCategoryEntity } from "../PlanningEventCategoryEntity";
import { WorkPackageEntity } from "../WorkPackageEntity";
import { PlanningEventLogEntity } from "../PlanningEventLogEntity";
import { PlanningEventEntity } from "../PlanningEventEntity";
declare global {
    interface EntityTypeMap {
        PlanningEvent: PlanningEventEntity;
    }
}
export abstract class PlanningEventGeneratedEntity extends BaseEntity {
    public abstract planningEventId: string;
    public abstract templateId: string | null;
    public abstract text: string;
    public abstract creationDate: Date;
    public abstract startDate: Date;
    public abstract endDate: Date | null;
    public abstract progress: number;
    public abstract project: ProjectEntity;
    public abstract category: PlanningEventCategoryEntity | null;
    public abstract workPackage: WorkPackageEntity | null;
    public abstract readonly planningEventLogs: ReadonlyArray<PlanningEventLogEntity>;
}
